import { useId } from "react";
import type { FormEvent } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router";

const MIN_QUERY = 2;
const MAX_QUERY = 100;

/** The staff header's search: Enter opens the results for the trimmed query.
 *  On the results page the box shows the query it is showing. */
export function StaffSearchBox(): React.ReactElement {
  const id = useId();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const current = pathname === "/staff/search" ? (params.get("q") ?? "") : "";

  const submit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    const q = String(new FormData(e.currentTarget).get("q") ?? "").trim();
    if (q.length < MIN_QUERY) return;
    void navigate(`/staff/search?q=${encodeURIComponent(q)}`);
  };

  return (
    <form role="search" onSubmit={submit} className="order-last w-full sm:order-none sm:w-auto sm:max-w-md sm:flex-1">
      <label htmlFor={id} className="sr-only">
        Search
      </label>
      <input
        // Re-mount when the shown query changes, so the box follows Back and Forward.
        key={current}
        id={id}
        name="q"
        type="search"
        // The server refuses a query over 100 characters.
        maxLength={MAX_QUERY}
        defaultValue={current}
        placeholder="Search companies, employees, email"
        className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm"
      />
    </form>
  );
}
